/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Role_AdminInputs */

const en_team_manager_role_admin = /** @type {(inputs: Team_Manager_Role_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin`)
};

const fr_team_manager_role_admin = /** @type {(inputs: Team_Manager_Role_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administrateur`)
};

const de_team_manager_role_admin = /** @type {(inputs: Team_Manager_Role_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administrator`)
};

const it_team_manager_role_admin = /** @type {(inputs: Team_Manager_Role_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amministratore`)
};

const ru_team_manager_role_admin = /** @type {(inputs: Team_Manager_Role_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Администратор`)
};

const es_team_manager_role_admin = /** @type {(inputs: Team_Manager_Role_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administración`)
};

const zh_cn2_team_manager_role_admin = /** @type {(inputs: Team_Manager_Role_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`行政`)
};

const ja_team_manager_role_admin = /** @type {(inputs: Team_Manager_Role_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理者`)
};

const hi_team_manager_role_admin = /** @type {(inputs: Team_Manager_Role_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`व्यवस्थापक`)
};

const pt_pt2_team_manager_role_admin = /** @type {(inputs: Team_Manager_Role_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administrador`)
};

/**
* | output |
* | --- |
* | "Admin" |
*
* @param {Team_Manager_Role_AdminInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_role_admin = /** @type {((inputs?: Team_Manager_Role_AdminInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Role_AdminInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_role_admin(inputs)
	if (locale === "de") return de_team_manager_role_admin(inputs)
	if (locale === "it") return it_team_manager_role_admin(inputs)
	if (locale === "ru") return ru_team_manager_role_admin(inputs)
	if (locale === "es") return es_team_manager_role_admin(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_role_admin(inputs)
	if (locale === "ja") return ja_team_manager_role_admin(inputs)
	if (locale === "hi") return hi_team_manager_role_admin(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_role_admin(inputs)
	return en_team_manager_role_admin(inputs)
});